export const DataTestSelector = (key: string, param?: string) => {
   const formattedParams = param
      ?.toLowerCase()
      .replace(/[^\p{L}\p{N}_-]+/gu, '-')
      .replace(/-{2,}/g, '-')
      .replace(/^[-]+|[-]+$/g, '');

   return { 'test-selector': `${key}${formattedParams ? `-${formattedParams}` : ''}` };
};
